<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" :style="($store.state.currentLocation.state == 'TAS') ? { width: '80%' } : { width: '30%'}">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">New {{$store.state.company.type == 'warehouse' ?  'Destruction' : 'Disposal'}}</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <!-- action="{{ url('payment') }}" -->
                        <!-- aria-label="{{ __('PaymentSubmit') }}" -->
                        <form class="action-modal">

                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                            <div class="form-section-container" :style="($store.state.currentLocation.state == 'TAS') ? { gridTemplateColumns: '2fr 9fr', width: '100%' } : { } ">
                                <div class="left-form-section-panel" style="min-height: fit-content">
                                    <p @click="addToPending()"
                                        :class="[form.submit.pending || ispendingDestruct ? 'selected-hollow-button' : '']"
                                        :style="form.submit.pending || ispendingDestruct ? {color: 'white'}:{color: '#0870DC'}"
                                        style="padding: 3px 10px; height: 30px; width: 100%; border-radius: 8px; border: 2px solid #0870DC; cursor: pointer; margin-bottom: 5px; font-weight: bold;  ">
                                        {{ form.submit.pending || ispendingDestruct ? 'Adding to pending list' : 'Add to pending list?' }}
                                    </p>
                                    <div v-if="!form.submit.pending && !ispendingDestruct">
                                        <div>
                                            <p style="text-align: left">Reason for {{$store.state.company.type == 'warehouse' ?  'Destruction' : 'Disposal'}} <span style="font-size: 10px; color:red">*</span></p>
                                            <textarea name="notes" id="note-modal" rows="14" cols="44"
                                            :placeholder="$store.state.company.type == 'warehouse' ?  'Please enter reason for destruction here...' : 'Please enter reason for disposal here...'"
                                            style="width: 100%; border-radius: 0px 0px 8px 8px;"
                                            v-model="form.submit.notes"></textarea>
                                        </div>

                                        <!-- METHOD -->
                                        <p style="text-align: left">{{ $store.state.company.type == 'warehouse' ?  'Method of Destruction' : 'Method of Disposal' }} <span style="font-size: 10px; color:red">*</span></p>
                                        <input v-model="form.submit.method" :placeholder="$store.state.company.type == 'warehouse' ?  'Please enter method of Destruction' : 'Please enter method of Disposal'"
                                            style="position: relative; width: 100%;margin-bottom: 5px" />
                                    
                                        <p style="text-align: left">Courier Name</p>
                                        <input v-model="form.submit.courier_name" placeholder="Please enter courier Name"
                                                style="position: relative; width: 100%;margin-bottom: 5px; background-color: #E5F1FE;" />
                                                
                                        <p style="text-align: left">Courier Notes</p>
                                        <input v-model="form.submit.courier_notes" placeholder="Please enter courier Notes"
                                                style="position: relative; width: 100%;margin-bottom: 5px; background-color: #E5F1FE;" />
                                    </div>
                                </div>
                                <!-- RIGHT SIDE PANEL -->
                                <div class="right-form-section-panel" style="display: flex; flex-direction: column;">
                                    <!-- BEFORE THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <!-- BEFORE THEY CHOOSE IMPREST OR PATIENT OWNED MEDS -->
                                    <div v-if="patient && patient.personal_information && patient.regulatory_information"
                                        class="individual-patient-container">
                                        <!-- <div class="patient-result-image" style="width: 100px; height: 100px; background-color: salmon">

                                </div> -->
                                        <div class="patient-result-info">
                                            <p><b>Name:</b> {{ patient.personal_information.first_name }}
                                                {{ patient.personal_information.last_name }}</p>
                                            <p v-if="patient.regulatory_information.length"><b>{{
                                                patient.regulatory_information[0].regulatory_type
                                            }}:</b>
                                                {{ patient.regulatory_information[0].data }}</p>
                                            <p><b>DOB:</b> {{
                                                patient.personal_information ?
                                                    patient.personal_information.dob : ''
                                            }}</p>
                                            <p><b>Location:</b> {{
                                                patient.physical_location &&
                                                    patient.physical_location.location ?
                                                    patient.physical_location.location.name : ''
                                            }}</p>
                                        </div>
                                    </div>



                                    <div v-if="($store.state.currentLocation?.facility?.medication_movement_default === 2) && !patient && !ispendingDestruct" style="margin-bottom: 10px;">
                                        <p class="submit-button blue-button" @click="displayPatientSearchModal = true" style="display: inline-block; width: auto; padding: 10px 20px; cursor: pointer;">
                                            Search {{ $resident({ capitalize: true }) }}
                                        </p>
                                    </div>

                                     <div v-if="(!$store.state.currentLocation?.facility?.medication_movement_default || $store.state.currentLocation?.facility?.medication_movement_default === 0) && (!imprest_pom || (imprest_pom === 'pom' && !patient)) && !ispendingDestruct">
                                         <p
                                             style="margin: 0; padding: 0; padding-bottom: 10px; font-size: 0.95em; text-align: left;">
                                             Please select whether this is imprest/emergency meds/ward stock or {{ $resident({ lowercase: true }) }} medication.</p>
                                         <div class="right-form-section-drug-entry">
                                             <div class="pom-imprest-select">
                                                 <p @click="() => { imprest_pom = 'pom'; displayPatientSearchModal = true }"
                                                     class="pom-imprest-choice-button"
                                                     v-bind:class="[imprest_pom == 'pom' ? 'active-select-filter' : '']">
                                                     {{ $resident({ capitalize: true }) }} Medication</p>
 
                                                 <p @click="() => { imprest_pom = 'imprest'; }"
                                                     class="pom-imprest-choice-button"
                                                     v-bind:class="[imprest_pom == 'imprest' ? 'active-select-filter' : '']"
                                                    >
                                                     Imprest/Emergency Meds/Ward Stock</p>
 
                                             </div>
                                         </div>
                                     </div>

                                     <div v-if="imprest_pom === 'pom' && !patient && !ispendingDestruct" class="resident-help-note">
                                         Before handling stock, please choose the {{ $resident({ lowercase: true }) }} it belongs to.
                                     </div>


                                    <!-- PATIENT MEDICATION SEARCH -->
                                    <div class="right-form-section-drug-entry" v-if="patient">
                                        <div style="width: 100%; margin-right: 10px">

                                            <Dropdown
                                                id="pom-select"
                                                v-model="stock"
                                                ref="med" @change="drugSelect(stock)"
                                                @input="show()"
                                                :loading="loadingDrugs"
                                                :options="filteredPatientMeds"
                                                optionLabel="full_name"
                                                optionDisabled="disabled"
                                                :editable="true"
                                                :emptyMessage="stockPickerEmptyMessage(stock, `No medications held for this ${$resident({ lowercase: true })}.`)"
                                                style="width: 100% !important; display: flex" placeholder="Select Medication"
                                            />
                                        </div>

                                        <input v-model="qty" min="0" type="number" placeholder="Quantity"
                                            style="position: relative; width: 30%; margin-right: 10px;" />
                                        <p class="submit-button blue-button"
                                            @click="() => { if (qty) { aliasSelect(stock) } }">
                                            Add</p>
                                    </div>


                                    <!-- <div class="right-form-section-drug-entry" v-if="imprest_pom == 'imprest'">
                                        <div style="width: 40%;">
                                            <input v-model="stock" placeholder="Select Stock"
                                                style="position: relative; width:100%" />
                                        </div>

                                        <input v-model="qty" type="number" placeholder="Enter quantity"
                                            style="position: relative; width: 40%" />
                                        <p class="submit-button blue-button"
                                            @click="() => { if (qty) { checkAndAddStock(stock) } }">Add</p>
                                    </div>
                                    <div class="drug-variances-container" style="display: flex; height: fit-content"
                                        v-show='refinedDrugs.length'>
                                        <p style="padding: 3px 10px; margin-right: 5px;">Select stock: </p>
                                        <p v-for="(item, index) in refinedDrugs" :key="index" @click="aliasSelect(item)"
                                            style="padding: 3px 10px; height: fit-content; margin-right: 10px; border-radius: 8px; border: 2px solid green; cursor: pointer">
                                            {{ item.alias.name }} <span style="font-weight: bold">In Stock:
                                                {{ item.qty_left }}</span>
                                        </p>
                                    </div>
                                    <div v-if="Array.isArray(refinedDrugs) && refinedDrugs.length == 0">
                                        <p style="font-size: 1em;">No stock found for that item.</p>
                                    </div> -->

                                    <!-- MED DROP DOWN -->
                                    <!-- MED DROP DOWN -->
                                    <!-- MED DROP DOWN -->
                                    <div class="right-form-section-drug-entry" v-if="(imprest_pom == 'imprest' && !ispendingDestruct)">
                                        <div style="display: flex; width: 100%">
                                            <!-- <Dropdown v-model="stock" ref="med" @change="drugSelect(stock), show()" @keyup="searchDrugs(stock), show()" :loading="loadingDrugs" :options="drugList" optionLabel="full_name" :editable="true"
                                            style="width: 25em; display: flex" optionDisabled="disabled" placeholder="Type medication name here"/> -->
                                            <!-- <Dropdown v-model="stock" ref="med" @change="drugSelect(stock)"
                                                @keyup="debounceSearchDrugs(stock), show()" :loading="loadingDrugs"
                                                :options="drugList" optionLabel="full_name" :editable="true"
                                                style="width: 25em; display: flex" placeholder="Select Medication" /> -->
                                                  <!-- <input id="medication" placeholder="Search a Supplier..." style="position: relative" /> -->
                                                    <Dropdown
                                                      v-model="stock"
                                                      ref="med"
                                                      @keyup="debounceSearchDrugs(stock), show()"
                                                      @change="drugSelect(stock)"
                                                      @focus="onDrugFocus"
                                                      :loading="loadingDrugs"
                                                      :options="drugList"
                                                      optionLabel="full_name"
                                                      optionDisabled="disabled"
                                                      :editable="true"
                                                      :emptyMessage="stockPickerEmptyMessage(stock)"
                                                      style="width: 25em; display: flex; width: 100%"
                                                      placeholder="Select Medication"
                                                    />
                                        </div>
                                        <BatchSelect :stockItem="selectedDrug.full_item" v-model="selectedBatch" />
                                        <input v-model="qty" min="0" type="number" placeholder="Enter qty"
                                            style="position: relative; width: 20%" />
                                        <p :class="batchRequiredAndMissing ? 'submit-button grey-button' : 'submit-button blue-button'"
                                            @click="() => { if (qty && !batchRequiredAndMissing) { checkIfExistingItem(selectedDrug.full_item) } }">
                                            Add</p>
                                        <!-- <p class="submit-button grey-button" style="background-color: black !important"
                                        @click="() => { if (qty) { imprest_pom = ''; stock=''; qty=''; refinedDrugs = []; patient = '' } }">Cancel</p> -->
                                    </div>


                                    <div class="right-form-section-drug-container" v-if="!ispendingDestruct">
                                        <table style="border-collapse: collapse">
                                            <tr v-if="form.submit.drugs && form.submit.drugs.length > 0">
                                                <th>Drug Name, Strength, Form</th>
                                                <th v-if="showBatchColumn">Batch no.</th>
                                                <th>Stock Qty</th>
                                                <th>Supplied</th>
                                                <th v-if="$store.state.company.type !== 'warehouse'">Expected Qty</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'">Count</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="width: 80px">Diff</th>
                                                <th v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center">Confirm</th>
                                                <th></th>
                                            </tr>
                                            <tr v-for="(item, index) in form.submit.drugs" :key="index"
                                                class="drug-entry-transfer">
                                                <td style="width: 50%;">
                                                    <p>{{ item.stock.slice(0, 1).toUpperCase() + item.stock.slice(1) }}
                                                    </p>
                                                </td>
                                                <td v-if="showBatchColumn">
                                                    <p style="width: max-content;">
                                                        {{ item.batch_number }}
                                                    </p>
                                                </td>
                                                <td>
                                                    {{ item.qty_left ? item.qty_left : 0}}
                                                </td>
                                                <td>
                                                    {{ item.qty }}
                                                </td>
                                                <td v-if="$store.state.company.type !== 'warehouse'">
                                                    <p>{{ (item.qty_left ? item.qty_left : 0) - item.qty }}</p>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <input style="width: 8em; background-color: white;" v-model="item.actual_balance" type="number" min="0" @input="onQtyRemainingChange(item)"/>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: left">
                                                    <span :class="(item.actual_balance - ((item.qty_left ? item.qty_left : 0) - item.qty) >= 0) ? 'green-tag' : 's8-tag'">{{ item.actual_balance - ((item.qty_left ? item.qty_left : 0) - item.qty) }}</span>
                                                </td>
                                                <td v-if="$store.state.currentLocation.state == 'TAS'" style="text-align: center; width: 40px">
                                                    <Checkbox :binary="true" v-model="item.balance_confirmed"/>
                                                </td>
                                                <td>
                                                    <div>
                                                        <p @click="removeDrug(index)"
                                                            class="red-close-button small-button">
                                                            <i class="pi pi-times" style='padding: 0'></i>
                                                        </p>
                                                    </div>
                                                </td>

                                            </tr>
                                        </table>
                                    </div>
                                    <div class="right-form-section-drug-container" v-if="ispendingDestruct">
                                        <table style="border-collapse: collapse">
                                            <tr v-for="(item, index) in form.submit.drugs" :key="index"
                                                class="drug-entry-transfer">
                                                <td v-if="checkItemBoxView" style="min-width: 15px;">
                                                                <div @click.stop="item.selected = !item.selected" style="cursor: pointer">
                                                                <div v-if="item.selected && (item.selected == true)" class="check-circle circle-on"></div>
                                                                <div v-else class="circle-off"></div>
                                                               </div>
                                                             </td>
                                                <td style="width: 50%;">
                                                    <p>{{ item.stock }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>
                                                        {{ item.qty }}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em;" v-if="errorMessage">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel
                        </p>
                         <!-- <p class="regular-button grey-button" @click="submitDestroyAndCreateNew()">Destroy
                            {{ form.submit.pending ? 'Later' : '' }} + New</p> -->
                        <p :class="buttonchangeUi()"  style="margin-right: 10px;" @click="submitDestroy()">
                            {{$store.state.company.type == 'warehouse' ?  'Destroy' : 'Dispose'}} {{ form.submit.pending ? 'Later' : '' }}</p>
                       
                    </slot>
                </div>
            </div>
        </div>
        <PatientSearchModal @close="close" v-if="displayPatientSearchModal" @patient="getPatient" />
        <!-- :witness="$store.state.currentLocation.state == 'WA'" -->
        <!-- :optional="form.submit.pending" -->
        <SuccessModal v-if="displayErrorModal" :first_spec_line="errorMessage" :statusMessage="errorTitle" @close="closeError" />
        <SignatureModal v-if="displaySignatureModal" :payload="realSubmit"  
            @isSuccessful="isSuccessful" :saveContext="saveContext" @close="close"
            :endpoint="'/location/' + $store.state.currentLocation.uuid + '/destroy'"
            :manual_loop="imprest_pom == 'imprest'  && $store.state.currentLocation.state == 'WA'"/>
    </div>
</template>

<script>
// import DualVerify from '@/components/verification/DualVerify.vue';
import SuccessModal from './SuccessModal.vue';
import SignatureModal from '@/components/modals/SignatureModal.vue';
import PatientSearchModal from '@/components/modals/PatientSearchModal.vue';
import axios from 'axios';
import { isPickerEmpty, pickerSearchTerm, stockPickerEmptyMessage } from '@/services/pickers';
import { debounce } from 'debounce';
import { decorateStockItems } from '@/services/stockItemDisplay';
import { filterMedicationList } from '@/services/FilterMedicationList';
import BatchSelect from '@/components/BatchSelect.vue';

export default {
    props: ['transferType','ispendingDestruct','checkItemBoxView','actionParentdata'],
    components: {
        // DualVerify,
        SuccessModal,
        SignatureModal,
        PatientSearchModal,
        BatchSelect
    },
    data() {
        return {
            witness: false,
            selectedDrug: {},
            drugList: [],
            // The batch chosen beside the picker for the row being added, cleared once the row is on
            // the list. BatchSelect also clears it whenever the medication changes.
            selectedBatch: null,
            loadingDrugs: false,
            imprest_pom: '',
            defaultApplied: false,
            pom: '',
            patient: '',
            gp: '',
            prescriberResults: [],
            addNew: false,
            patientMeds: [],
            prescriber: '',
            selectedPrescriber: '',
            errorTitle: '',
            errorMessage: '',
            displayErrorModal: false,
            displaySignatureModal: false,
            displayPatientSearchModal: false,
            newLoc: '',
            stock: '',
            reasonCat: '',
            reasonSubCat: '',
            qty: null,
            location: '',
            addNewLocation: false,
            noLocationFound: false,
            refinedLocations: null,
            refinedDrugs: '',
            form: {
                type: 'destroy',
                submit: {
                    patient_uuid: '',
                    prescriber_uuid: '',
                    method: '',
                    notes: '',
                    pending: false,
                    drugs: [],
                    courier_name: '',
                    courier_notes: ''
                }
            },
            // INFORMATION PROVIDED TO USER TO PROVIDE CONTEXT ON AUTOSAVE INFORMATION
            saveContext: {
                type: 'Destruction',
                patient: '',
                location: '',
            s: [],
                doubleSig: false
            },
            timeout: 0
        };
    },
    watch: {
        imprest_pom: {
            handler(newVal) {
                if (newVal === '') {
                    if (this.defaultApplied) return;
                    const movementDefault = this.$store.state.currentLocation?.facility?.medication_movement_default;
                    if (movementDefault === 1) {
                        this.imprest_pom = 'imprest';
                        this.defaultApplied = true;
                    } else if (movementDefault === 2) {
                        this.imprest_pom = 'pom';
                        this.defaultApplied = true;
                    }
                }
            },
            immediate: true
        }
    },
    computed: {
        // Show the batch column when any row actually carries a batch. This used to be keyed on the
        // company type, which meant an aged care user could not see the batch they had just chosen and
        // a warehouse user with unbatched stock got an empty column.
        showBatchColumn() {
            const rows = (this.form && this.form.submit && Array.isArray(this.form.submit.drugs)) ? this.form.submit.drugs : [];
            return rows.some(row => row && row.batch_number);
        },
        // The stock item holds batches and none has been chosen yet, so the row cannot be added. The
        // backend enforces the same thing, so this only saves the user a rejected submit.
        batchRequiredAndMissing() {
            const item = this.selectedDrug ? this.selectedDrug.full_item : null;
            const batches = (item && Array.isArray(item.batches)) ? item.batches : [];
            // The flag is checked here too, so a stale response carrying batches cannot leave Add
            // permanently disabled for a facility that has no batch dropdown to satisfy it with.
            return this.$store.getters.isBatchTrackingEnabled && batches.length > 0 && !this.selectedBatch;
        },
        // The resident's whole holding is loaded up front, so this dropdown has no server
        // side search behind it - the typed text filters the loaded list instead.
        filteredPatientMeds() {
            return filterMedicationList(this.patientMeds, this.stock);
        }
    },
    methods: {
        stockPickerEmptyMessage,
        show() {
            console.log('HITING SAVE FUNCTION');
            let interval = setInterval(() => {
                console.log('HITTING INTERVAL');
                if (!this.loadingDrugs && this.drugList) {
                    clearInterval(interval);
                    this.$refs.med.show();
                }
            }, 100)
        },
        debounceSearchDrugs: debounce(function() {
                this.searchDrugs()
        },[500]),
        drugSelect(item) {
            if (typeof item === 'string' || !item) return;
            this.loadingDrugs = true;
            console.log('this is the drug item selected', item);
            this.selectedDrug.full_item = item;
            this.selectedDrug.drug_uuid = item.alias.alias_id;
            this.selectedDrug.full_name = item.full_name;
            this.selectedDrug.form = item.alias && item.alias.form ? item.alias.form[0].toUpperCase() + item.alias.form.slice(1) : '';
            this.selectedDrug.strength = `${item.alias ? item.alias.strength : ''}`;
            this.selectedDrug.measurement_unit = `${item.alias ? item.alias.measurement_unit : ''}`;
            
            let itemName = item.alias ? item.alias.name : '';
            this.selectedDrug.name = itemName ? itemName[0].toUpperCase() + itemName.slice(1) : '';
            this.selectedDrug.tags = item.alias.tags;
            this.loadingDrugs = false;
        },
        onDrugFocus() {
            if (this.imprest_pom === 'imprest') {
                if (isPickerEmpty(this.stock)) {
                    this.searchDrugs(true);
                    this.show();
                }
            }
        },
        searchDrugs(fetchDefault = false) {
            // Only typed text is a search; a held selection has nothing left to look up.
            const searchTerm = pickerSearchTerm(this.stock);
            if (searchTerm || fetchDefault) {
                this.loadingDrugs = true;
                axios.post('/get-stock-items', { drug: searchTerm, patient_id: this.patient ? this.patient.uuid : null }, this.$store.state.header).then(res => {
                    console.log('this is the res data getstockitems', res.data);
                    this.$store.dispatch('getRefreshToken');
                    this.drugList = decorateStockItems(res.data, { showBatch: this.$store.state.company.type !== 'aged care' });
                    this.errorMessage = '';
                    this.loadingDrugs = false;
                }).catch(err => {
                    this.loadingDrugs = false;
                    if (err.response && err.response.data && err.response.data.split(' ').includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                    console.log('this is the transfer stock items error', err.response.data);
                    this.errorMessage = err.response.data;
                })
            }
        },
        checkIfExistingItem(item) {
            let exit = false;
            // The batch is part of what makes a row, not just the drug. Two batches of the same
            // medication are two rows - matching on the drug alone overwrote the first row's
            // quantity while it kept the first batch, so the stock came off the wrong batch.
            const batchUuid = this.selectedBatch ? this.selectedBatch.uuid : null;
            if (this.form.submit.drugs.length) {
                this.form.submit.drugs.forEach((drugItem, index) => {
                    console.log('LOOPING THROUGH LIST', drugItem, item);
                    if (((item.uuid == drugItem.drug) || (item.alias_id == drugItem.drug)) && ((drugItem.batch_uuid ?? null) === batchUuid) && !exit) {
                        console.log('HIT A MATCH', drugItem);
                        drugItem.qty = this.qty;
                        exit = true;
                    // Only once the whole list has been checked, as the other modals do. Adding on
                    // the first row that did not match meant a medication already in the list was
                    // added a second time whenever it was not the first row.
                    } else if (!exit && ((index + 1) == this.form.submit.drugs.length)) {
                        this.aliasSelect(item);
                        exit = true;
                    }
                })
            } else {
                this.aliasSelect(item);
            }
        },
        // checkIfExistingItem(){
        //         const existDrug = this.form.submit.drugs.filter((item)=>{
        //         return item?.drug === this.stock?.uuid
        //     })
        //     if (existDrug?.length > 0) {
        //         this.errorMessage = "Duplicate medication selected"
        //         return ;
        //     }else{
        //         this.errorMessage = ''
        //         const algoliaDrug = {
        //             drug: this.stock?.uuid,
        //             medication: this.stock?.alias.name,
        //             qty: 0
        //         }
        //         if (this.stock?.uuid) {
        //             this.form.submit.drugs.push(algoliaDrug)
        //             this.addingMed = true
        //             if (this.addingMed) {
        //                 this.stock = null
        //             }
        //         }
        //     }
        // },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        },
        closeLocationModal(value) {
            if (value) {
                this.addNewLocation = false;
            }
        },
        close(value) {
            if (value) {
                this.witness = false;
                this.displaySignatureModal = false;
                if (this.imprest_pom != 'imprest' && !this.patient) {
                    this.displayPatientSearchModal = false;
                    this.imprest_pom = '';
                }
            }
        },
        isSuccessful(value) {
            if (value) {
                if (window.location.pathname == '/stock/destructions') {
                    this.$store.dispatch('getDestructionItems', {
                        sort_direction: '',
                        col: '',
                        page: 1,
                        location: this.$store.state.uuid,
                        filters: {
                            status: this.form.submit.pending || this.ispendingDestruct ? "pending" : "completed",
                            drug: '',
                            date: {
                                start: '',
                                end: ''
                            }
                        }
                    })
                }
                if (this.addNew) {
                    this.form.submit.drugs = [];
                    this.defaultApplied = false;
                    this.imprest_pom = '';
                    this.patient = '';
                    this.patient_uuid = '';
                    this.prescriber_uuid = '';
                    this.selectedPrescriber = '';
                } else {
                    this.$emit('close', true, this.form.submit.pending || this.ispendingDestruct ? "pending" : "completed");
                }
            }

        },
        addToPending() {
            if(!this.ispendingDestruct){
                if (this.form.submit.pending) {
                 this.form = {
                    type: 'destroy',
                    submit: {
                        patient_uuid: '',
                        prescriber_uuid: '',
                        method: '',
                        notes: '',
                        pending: this.form.submit.pending,
                        drugs: this.form.submit.drugs,
                        courier_name: '',
                        courier_notes: ''
                    }
                }
            }
                this.form.submit.pending = !this.form.submit.pending;
            }
        },
        addToReason(reason) {
            this.form.submit.reason = reason;
            this.reasonCat = '';
            console.log('DOES IT CONTAIN RETURN STOCK TO PHARM?', this.form.submit.reason.includes('Return Stock to Pharmacy'))
            if (this.form.submit.reason == 'Damaged or Expired Stock') {
                this.reasonCat = '';
                this.reasonSubCat = '';
            } else {
                this.reasonCat = 'Return Stock to Pharmacy';
            }
            if (reason == 'From Doctor' || reason == 'From Resident') {
                this.form.submit.reason = 'Return Stock to Pharmacy -' + reason
                        this.reasonSubCat = reason;
            }
        },
        aliasSelect(item) {
            console.log('this is the alias select item', item);
            let quantity = item.quantity !== undefined ? item.quantity : item.qty_left;
            // if((this.imprest_pom == 'imprest')){
            // axios.post('/get-stock', {alias_id:item.alias_id, location_id: this.$store.state.uuid }, this.$store.state.header).then(res=>{

            //         console.log('this is the quantity if condition',res, this.qty, res.data.qty_left, this.qty > res.data.qty_left);
            //         this.form.submit.drugs.unshift({tags: res.data.tags, stock: res.data.alias.name, form:res.data.alias.form, drug:res.data.uuid, qty_left: res.data.qty_left, qty: this.qty <= Number(res.data.qty_left) ? Number(this.qty).toFixed(1) : Number(res.data.qty_left).toFixed(1)});

            //     this.$store.dispatch('getRefreshToken');
            //     this.qty = null;
            //     this.refinedDrugs = [];
            //     this.noStock = false;
            // }).catch(err=>{
            //     console.log('err is', err.response.data);
            //     if(err.response.data == 'No stock has been recorded on this location for that drug alias.'){
            //         console.log('hitting the if condition');
            //         this.form.submit.drugs.unshift({tags: item.tags, stock:item.name, drug: item.alias_id, form: item.form, qty:'None in stock.', qty_left: 0});
            //     }
            //     this.qty = null;
            //     this.refinedDrugs = [];
            // })} else{
            //     this.form.submit.drugs.unshift({tags: item.tags, stock: item.name, form:item.form, qty_left:item.quantity, drug:item.uuid, qty: this.qty <= Number(item.quantity) ? this.qty : Number(item.quantity)});
            // }

            if ((this.imprest_pom == 'imprest' || this.imprest_pom == '')) {
                this.form.submit.drugs.unshift({ 
                    tags: item.alias.tags, 
                    stock: item.alias.name, 
                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                    drug: item.uuid, 
                    form: item.alias.form, 
                    qty: this.qty, 
                    qty_left: item.qty_left,
                    balance_confirmed: true, 
                    actual_balance: Number(item.qty_left) - Number(this.qty)
                });
                this.qty = null;
                this.selectedBatch = null;
                this.refinedDrugs = '';
                this.noStock = false;
                this.loadingDrugs = false;
                this.stock = '';
                this.selectedDrug = {};
                this.addingMed = false;
            } else {
                this.form.submit.drugs.unshift({ 
                    tags: item.alias ? item.alias.tags : '', 
                    stock: item.alias.name, 
                    batch_number: this.selectedBatch ? this.selectedBatch.batch_name : item.batch_number,
                    batch_uuid: this.selectedBatch ? this.selectedBatch.uuid : null,
                    form: item.alias.form, 
                    qty_left: quantity, 
                    drug: item.uuid, 
                    qty: this.qty <= Number(quantity) ? this.qty : Number(quantity),
                    balance_confirmed: true, 
                    actual_balance: Number(quantity) - Number(this.qty <= Number(quantity) ? this.qty : Number(quantity))
                });
            }
        },
        onQtyRemainingChange(item) {
            console.log('Quantity remaining changed:', item.actual_balance);
            item.balance_confirmed = (Number(item.actual_balance) == (Number(item.qty_left) - Number(item.qty))) ? true : false;
        },
        removeDrug(index) {
            console.log('this is the index', index, this.form.submit.drugs);
            this.form.submit.drugs.splice(index, 1);
        },
        buttonchangeUi(){
            if (this.$store.state.company.type == 'warehouse') {
                
                const selectData1 = this.form.submit.drugs.filter((item)=> item?.selected && item.selected === true)
                if (this.checkItemBoxView) {
                    if (this.ispendingDestruct) {
                        if (selectData1?.length > 0) {
                        return 'regular-button green-button'
                    }
                    else{
                        return 'regular-button grey-button'
                    }
                    }else{
                        if (selectData1?.length > 0 && this.form.submit.drugs && this.form.submit.notes && this.form.submit.courier_name && this.form.submit.courier_notes && this.form.submit.method) {
                        return 'regular-button green-button'
                    }
                    else{
                        return 'regular-button grey-button'
                    }
                    }
                }else{
                    if (this.form.submit.pending) {
                        if(this.form.submit.drugs?.length > 0){
                        return 'regular-button green-button'
                    }
                    else{
                        return 'regular-button grey-button'
                    }
                    }else{
                    if(this.form.submit && this.form.submit.notes && this.form.submit.courier_name && this.form.submit.courier_notes && this.form.submit.drugs?.length > 0 && this.form.submit.method){
                        return 'regular-button green-button'
                    }
                    else{
                        return 'regular-button grey-button'
                    }
                }
                }
            }else{
                return 'regular-button green-button'
            }
        },
        closeError(value) {
            if (value) {
                this.errorTitle = '';
                this.errorMessage = '';
                this.displayErrorModal = false;
            }
        },
        submitDestroy() {
            if (!this.form.submit.pending && this.form.submit.notes.trim() == '') {
                this.displayErrorModal = true;
                this.errorTitle = 'Error';
                this.errorMessage = 'Reason for disposal is required';
                return;
            }
            if (!this.form.submit.pending && this.form.submit.method.trim() == '') {
                this.displayErrorModal = true;
                this.errorTitle = 'Error';
                this.errorMessage = 'Disposal method is required';
                return;
            }
            // this.$store.dispatch('submitForm',this.form);
            // let testID = "c309671f-2c62-3b0e-8088-4f0bd851f0e5";
            let newDrugSub = [];
            // LOCAL VARIABLE FOR DRUG CONTEXT AUTOCACHE
            let autoDrugs = [];
            this.addNew = false;
            if (this.ispendingDestruct) {
                const filterdata = this.form.submit.drugs.filter((item)=> item?.selected && item.selected === true)
                filterdata.forEach(item => {
                    let p = {
                        drug: item.drug,
                        qty: Number(item.qty),
                        alias:  item.stock,
                        tags: item?.tags,
                        batch_uuid: item?.batch_uuid,
                        batch_item_id:item?.batch_item_id
                    }
                    let ad = {
                        drug: item.stock,
                        qty: Number(item.qty),
                        tags: item?.tags,
                        batch_uuid: item?.batch_uuid,
                        batch_item_id:item?.batch_item_id
                    }
                    autoDrugs.push(ad);
                    newDrugSub.push(p);
                    if (item.tags && item.tags.length) {
                        this.witness = true;
                    }
                });
            }else{
                this.form.submit.drugs.forEach(item => {
                    let p = {
                        drug: item.drug,
                        qty: Number(item.qty),
                        alias:  item.stock,
                        tags: item.tags,
                        balance_confirmed: item.balance_confirmed,
                        actual_balance: item.actual_balance,
                        // The batch chosen beside the picker. Null where the stock item holds none;
                        // BatchSelectionRule rejects the row if it holds batches and this is missing.
                        batch_uuid: item?.batch_uuid ?? null,
                    }
                    let ad = {
                        drug: item.stock,
                        qty: Number(item.qty),
                        tags: item.tags
                    }
                    autoDrugs.push(ad);
                    newDrugSub.push(p);
                    if (item.tags && item.tags.length) {
                        this.witness = true;
                    }
                });
            }
            this.realSubmit = {
                drugs: newDrugSub,
                notes: `${this.ispendingDestruct ? true : this.form.submit.pending ? '' : this.$store.state.company.type == 'warehouse' ?  'Reason for Destruction: ' : 'Reason for Disposal: ' + this.form.submit.notes}` +  ` ${this.ispendingDestruct ? true : this.form.submit.pending ? '': '-- Method of Disposal: '+this.form.submit.method}. ${this.ispendingDestruct ? true : this.form.submit.pending ? ' Stock quarantined in safe awaiting disposal':''}`,
                method: this.form.submit.method,
                pending: this.ispendingDestruct ? true : this.form.submit.pending,
                prescriber_uuid: this.selectedPrescriber ? this.selectedPrescriber.uuid : '',
                patient_uuid: this.patient ? this.patient.uuid : '',
                // patient_uuid: this.patient ? testID : '',
                courier_name: this.form.submit.courier_name,
                courier_notes: this.form.submit.courier_notes
            };
            this.saveContext = {
                drugs: autoDrugs,
                location: JSON.parse(localStorage.getItem('currentLocation')).name,
                patient: this.patient ? `${this.patient.personal_information.first_name} ${this.patient.personal_information.last_name}` : 'Imprest/Emergency Stock',
                supplemental: this.patient && this.patient.regulatory_information.length ? `${this.patient.regulatory_information[0].regulatory_type}: ${this.patient.regulatory_information[0].data}` : ``,
                doubleSig: this.witness ? true : false,
                notes: this.form.submit.notes,
                courier_name: this.form.submit.courier_name,
                courier_notes: this.form.submit.courier_notes,
                method: this.form.submit.method,
                type: 'Destruction'
            }
            // this.realSubmit.drugs = newDrugSub;
            console.log('this is the form to submit', this.form, newDrugSub);
            console.log('this is the SAVE CONTEXT', this.saveContext);
            console.log('DRUG SUB', newDrugSub);
            console.log(this.form.submit.drugs.length && this.form.submit.notes);
            if (this.ispendingDestruct) {
                if (this.realSubmit?.drugs.length > 0) {
                    this.displaySignatureModal = true;
                    this.errorMessage = '';
                } else {
                    this.errorMessage = 'Medications field are required.'
                }
            }else{
                if (this.$store.state.company.type == 'warehouse') {
                    if (this.form.submit.pending) {
                        if (this.form.submit.drugs.length) {
                            this.displaySignatureModal = true;
                            this.errorMessage = '';
                        } else {
                            this.errorMessage = 'Medications field are required.'
                        }
                    } else {
                        if (this.form.submit.drugs.length && this.form.submit.notes) {
                            this.displaySignatureModal = true;
                            this.errorMessage = '';
                        } else {
                            this.errorMessage = 'Medications, reason for destruction and method fields are required.'
                        }

                    }
                } else {
                    this.displaySignatureModal = true;
                    this.errorMessage = '';
                }
            }
            this.refinedLocations = [];
        },
        selectPrescriber(prescriber) {
            console.log('this is the selected result', this.nonGP);
            this.prescriberResults = [];
            this.selectedPrescriber = {
                prescriber_no: prescriber.regulatory_numbers.length ? prescriber.regulatory_numbers[0].data : '',
                uuid: prescriber.uuid,
                first_name: prescriber.first_name,
                last_name: prescriber.last_name,
                phone: prescriber.phone,
                after_hours: prescriber.after_hours,
                address: prescriber.address,
                email: prescriber.email,
                fax: prescriber.fax,
                primary_gp: false
            }
        },
        changePrescriber() {
            this.selectedPrescriber = '';
            this.gp = '';
        },
        getPatient(value) {
            if (value) {
                this.patient = value;
                this.displayPatientSearchModal = false;
                // Strict patient endpoint (person_id = patient only), same as the
                // administration/delivery modals. /get-stock-items also returns
                // person-less imprest stock when given a patient_id (it serves the
                // drug search box below), which leaked location stock into this
                // dropdown as if the patient held it.
                axios.post(`/person/${this.patient.uuid}/stock-register`, {}, this.$store.state.header).then(res => {
                    console.log('this is the patient register', res);
                    this.patientMeds = decorateStockItems(res.data);
                    // The add flow reads `qty` off the selected option before the user types one.
                    this.patientMeds.forEach(item => { item.qty = Number(item.quantity); });
                })
            }
        },
        submitDestroyAndCreateNew() {
            if (this.form.submit.drugs.length && this.form.submit.notes) {
                this.addNew = true;
                let newDrugSub = [];
                this.form.submit.drugs.forEach(item => {
                    let p = {
                        drug: item.drug,
                        qty: Number(item.qty)
                    }

                    if (item.qty > 0) {
                        newDrugSub.push(p);
                    }
                });
                this.realSubmit = {
                    drugs: newDrugSub,
                    notes: this.form.submit.notes,
                    method: this.form.submit.method,
                    pending: this.form.submit.pending,
                    prescriber_uuid: this.selectedPrescriber ? this.selectedPrescriber.uuid : '',
                    patient_uuid: this.patient ? this.patient.uuid : '',
                    courier_name: this.form.submit.courier_name,
                    courier_notes: this.form.submit.courier_notes
                };
                // this.$store.dispatch('submitDelivery',this.form);
                // this.refinedLocations = [];

                this.displaySignatureModal = true;
                this.errorMessage = '';
                this.stock = '';
            } else {
                this.errorMessage = 'Drugs and notes are required.'
            }
        },
        //     gpSearch(prescriber) {
        //         let headers = {
        //             "X-Algolia-API-Key": this.$store.state.VUE_APP_ALGOLIA_API_KEY,
                // "X-Algolia-Application-Id": this.$store.state.VUE_APP_ALGOLIA_APP_ID
        //         }
        //         // let results = [];
        //         this.prescriberResults = [];
        //         console.log('this is the drug', prescriber);
        //         // https://H4AK5A0Y5K-dsn.algolia.net/1/indexes/${this.$store.state.subdomain}_prescribers/browse
        //         axios.post(`https://H4AK5A0Y5K-dsn.algolia.net/1/indexes/*/queries`, 
        //         // params: `query=${prescriber}&hitsPerPage=5`,
        //         { 
        //           requests:[
        //             { "indexName": `${this.$store.state.subdomain}_prescribers`, "params":  `query=${prescriber}` },
        //             { "indexName": `${this.$store.state.subdomain}_prescriber_references`, "params":  `query=${prescriber}` },
        //           ]  
        //         },
        //             { headers }).then(res => {
        //                 console.log('this is the algolia res', res.data.results);
        //                 res.data.results.forEach(indexResult=>{
        //                     console.log('these are the results for this particular index', indexResult);
        //                     if(indexResult.hits.length){

        //                         // results.push(indexResult.hits);
        //                         indexResult.hits.forEach(hit=>{
        //                             this.prescriberResults.push(hit);
        //                         })
        //                         console.log('this is the local results varaible', this.prescriberResults);
        //                     }

        //                 })
        //                 // this.prescriberResults = res.data.hits;
        //                 // state.commit('setDrugNames', res.data.hits);
        //             })

        //    },
    

},
mounted() {
    if (this.actionParentdata?.items) {
            if (this.actionParentdata?.items?.length > 0) {
                this.form.submit.drugs = this.actionParentdata?.items
                this.addingMed = true
                return this.actionParentdata?.items
            }
        }
}
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

 

 

  


.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: $babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.right-form-section-panel {
    padding: 0 20px;
    overflow: auto !important;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: $complete;
    color: white;
}

.selected-hollow-button {
    background-color: $strongblue;
    color: white;
}
</style>